// Copyright ©️ 2025 eVolve MEP, LLC

import type { ValueFormatterParams } from 'ag-grid-enterprise';

import { isNotNil } from 'helpers/isNotNil';

const NUMBER_FORMATTER = new Intl.NumberFormat(undefined, { maximumFractionDigits: 3 });

/**
 * Formats a quantity to a string with up to 3 decimal places.
 * @param qty - The number to format. Allowed to be nullish.
 * @param fallback - A string to use if the number is nullish. Defaults to an empty string.
 */
export const formatQuantity = (qty: number | null | undefined, fallback = ''): string =>
  isNotNil(qty) ? NUMBER_FORMATTER.format(qty) : fallback;

export const destructureAndFormatQuantity = <T>({ value }: ValueFormatterParams<T, number | undefined | null>) =>
  formatQuantity(value);
